import useTrls from 'hooks/translation/useTrls';

import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

const Header = () => {
    const trl = useTrls();

    return (
        <TableRow>
            <TableHeadCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Payments.number')}</TableHeadCell>
            <TableHeadCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Payments.createdAt')}</TableHeadCell>
            <TableHeadCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Payments.amount')}</TableHeadCell>
            <TableHeadCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Payments.paymentDate')}</TableHeadCell>
            <TableHeadCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Payments.type')}</TableHeadCell>
            <TableHeadCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Payments.refund')}</TableHeadCell>
        </TableRow>
    );
};

export default Header;
